
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("bQSqB", function(module, exports) {
"use strict";
function $8a0ec55416c5068d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8a0ec55416c5068d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8a0ec55416c5068d$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
function $8a0ec55416c5068d$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $8a0ec55416c5068d$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $8a0ec55416c5068d$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($8a0ec55416c5068d$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $8a0ec55416c5068d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $8a0ec55416c5068d$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $8a0ec55416c5068d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $8a0ec55416c5068d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
// ====================================================================================
// donationProgress.module
// ====================================================================================
var $8a0ec55416c5068d$var$url2Base = "https://spenden.twingle.de/donation-status/amount-";
var $8a0ec55416c5068d$var$elements = document.querySelectorAll(".ctype-ce_donation_progress");
var $8a0ec55416c5068d$var$getCurr = function getCurr(val) {
    return val.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
    });
};
var $8a0ec55416c5068d$var$getInt = function getInt(val, decimals) {
    return val.toLocaleString("de-DE", {
        style: "decimal",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};
var $8a0ec55416c5068d$var$setAmount = function setAmount(el, amount) {
    var elAmount = el.element.querySelector(".amount");
    var elGoal = el.element.querySelector(".goal");
    var cAmount = amount / el.conversion;
    var cGoal = el.goal;
    var hasGoal = el.goal !== 0;
    if (hasGoal) {
        var percentage = cAmount / el.goal * 100;
        el.element.querySelector(".progress-bar").style.width = percentage + "%";
    }
    if (el.unit === "trees") {
        elAmount.innerHTML = "".concat($8a0ec55416c5068d$var$getInt(cAmount, 0), " B\xe4ume");
        if (hasGoal) elGoal.innerHTML = "".concat($8a0ec55416c5068d$var$getInt(cGoal, 0), " B\xe4ume");
    } else if (el.unit === "m2") {
        elAmount.innerHTML = "".concat($8a0ec55416c5068d$var$getInt(cAmount, 2), " m\xb2");
        if (hasGoal) elGoal.innerHTML = "".concat($8a0ec55416c5068d$var$getInt(cGoal, 2), " m\xb2");
    } else if (el.unit === "tons") {
        elAmount.innerHTML = "".concat($8a0ec55416c5068d$var$getInt(cAmount, 2), " t");
        if (hasGoal) elGoal.innerHTML = "".concat($8a0ec55416c5068d$var$getInt(cGoal, 2), " t");
    } else {
        elAmount.innerHTML = "".concat($8a0ec55416c5068d$var$getCurr(cAmount));
        if (hasGoal) elGoal.innerHTML = "".concat($8a0ec55416c5068d$var$getCurr(cGoal));
    }
};
var $8a0ec55416c5068d$var$getCurrentAmount = /*#__PURE__*/ function() {
    var _ref = $8a0ec55416c5068d$var$_asyncToGenerator(/*#__PURE__*/ $8a0ec55416c5068d$var$_regeneratorRuntime().mark(function _callee(el) {
        var combinedAmount, req0, data0, req1, data1, req2, data2;
        return $8a0ec55416c5068d$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    combinedAmount = el.analogue;
                    req0 = $8a0ec55416c5068d$var$url2Base + el.id;
                    _context.next = 4;
                    return fetch(req0).then(function(response) {
                        return response.json();
                    }) // Parse the response as JSON
                    .then(function(data) {
                        return data.status.amount;
                    })["catch"](function(error) {
                        return 0;
                    });
                case 4:
                    data0 = _context.sent;
                    // console.log("data0", data0);
                    combinedAmount += data0;
                    if (!el.id2) {
                        _context.next = 12;
                        break;
                    }
                    req1 = $8a0ec55416c5068d$var$url2Base + el.id2;
                    _context.next = 10;
                    return fetch(req1).then(function(response) {
                        return response.json();
                    }) // Parse the response as JSON
                    .then(function(data) {
                        return data.status.amount;
                    })["catch"](function(error) {
                        return 0;
                    });
                case 10:
                    data1 = _context.sent;
                    // console.log("data1", data1);
                    combinedAmount += data1;
                case 12:
                    if (!el.id3) {
                        _context.next = 18;
                        break;
                    }
                    req2 = $8a0ec55416c5068d$var$url2Base + el.id3;
                    _context.next = 16;
                    return fetch(req2).then(function(response) {
                        return response.json();
                    }) // Parse the response as JSON
                    .then(function(data) {
                        return data.status.amount;
                    })["catch"](function(error) {
                        return 0;
                    });
                case 16:
                    data2 = _context.sent;
                    // console.log("data2", data2);
                    combinedAmount += data2;
                case 18:
                    // console.log("combinedAmount", combinedAmount);
                    $8a0ec55416c5068d$var$setAmount(el, combinedAmount);
                case 19:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getCurrentAmount(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $8a0ec55416c5068d$var$init = module.exports.init = function init() {
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") $8a0ec55416c5068d$var$elements.forEach(function(element) {
            var data = element.dataset;
            var baseUrl = data.url;
            var additionalURL2 = data.url2;
            var additionalURL3 = data.url3;
            var el = {
                element: element,
                conversion: parseFloat(data.conversion),
                goal: parseFloat(data.goal),
                analogue: parseFloat(data.analogue),
                unit: data.unit
            };
            if (baseUrl !== "-") {
                var parsedBaseUrl = new URL(baseUrl);
                el.id = parsedBaseUrl.pathname.split("/").pop();
                if (additionalURL2 !== "-") {
                    var parsedAdditionalURL2 = new URL(additionalURL2);
                    el.id2 = parsedAdditionalURL2.pathname.split("/").pop();
                }
                if (additionalURL3 !== "-") {
                    var parsedAdditionalURL3 = new URL(additionalURL3);
                    el.id3 = parsedAdditionalURL3.pathname.split("/").pop();
                }
                $8a0ec55416c5068d$var$getCurrentAmount(el);
                var timer = setInterval(function() {
                    return $8a0ec55416c5068d$var$getCurrentAmount(el);
                }, 30000);
                window.addEventListener("beforeunload", function(event) {
                    clearInterval(timer);
                });
            } else $8a0ec55416c5068d$var$setAmount(el, parseFloat(data.analogue));
        });
        else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=donationProgress.module.e8c0fca0.js.map
